/**
 * 认证相关 API
 */
import request from './api';

export interface LoginParams {
  username: string;
  password: string;
}

export interface RegisterParams {
  username: string;
  password: string;
  nickname?: string;
  email?: string;
}

export interface UserInfo {
  id: string;
  username: string;
  nickname: string;
  avatar: string;
  email?: string;
  phone?: string;
  wechat?: string;
  role: string;
  is_vip: boolean;
  is_admin: boolean;
  created_at: string;
  // 所有自定义注册字段（来自 user_meta，动态键名如 field_2, field_3 等）
  [key: string]: unknown;
}

export interface AuthResponse {
  token: string;
  user: UserInfo;
}

/**
 * 用户登录
 */
export function login(params: LoginParams): Promise<AuthResponse> {
  return request<AuthResponse>('/auth/login', {
    method: 'POST',
    body: JSON.stringify(params),
  });
}

/**
 * 用户注册
 */
export function register(params: RegisterParams): Promise<AuthResponse> {
  return request<AuthResponse>('/auth/register', {
    method: 'POST',
    body: JSON.stringify(params),
  });
}

/**
 * 获取当前用户信息
 */
export function getCurrentUser(): Promise<UserInfo> {
  return request<UserInfo>('/auth/me');
}

/**
 * 找回密码
 */
export function resetPassword(username: string): Promise<void> {
  return request<void>('/auth/reset-password', {
    method: 'POST',
    body: JSON.stringify({ username }),
  });
}

/**
 * 修改密码
 */
export function changePassword(oldPassword: string, newPassword: string): Promise<void> {
  return request<void>('/auth/change-password', {
    method: 'POST',
    body: JSON.stringify({
      old_password: oldPassword,
      new_password: newPassword,
    }),
  });
}
